import React from 'react';
import { styled } from 'linaria/react';

const BrandWrapper = styled('div')`
  p {
    text-transform: uppercase;
  }
`;

export const Brand = ({ subName }) => {
  if (!subName || subName.length === 0) return null;

  return (
    <BrandWrapper>
      <p dangerouslySetInnerHTML={{ __html: subName }} />
    </BrandWrapper>
  );
};
